/* Belo PDP v2 — interactions for sections/belo2-*.liquid
   Gallery thumb swap · proof carousel arrows · timeline scroll
   activation · nutrition-panel dialog.
   Idempotent per root (data-b2-init) so Shopify theme-editor
   section reloads re-bind cleanly. */
(function () {
  'use strict';

  // Four sections load this file; run the module once no matter how many
  // <script> tags land on the page.
  if (window.__belo2Pdp) return;
  window.__belo2Pdp = true;

  function initGallery(root) {
    var main = root.querySelector('[data-b2-main] img');
    if (!main) return;
    root.querySelectorAll('[data-b2-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = btn.querySelector('img');
        if (!img) return;
        main.src = btn.dataset.full || img.src;
        if (btn.dataset.fullSrcset) main.srcset = btn.dataset.fullSrcset;
        else main.removeAttribute('srcset');
        main.alt = img.alt || main.alt;
        root.querySelectorAll('[data-b2-thumb]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-b2-track]');
    if (!track) return;
    root.querySelectorAll('[data-b2-arrow]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 16 : 240;
        track.scrollBy({
          left: btn.dataset.b2Arrow === 'next' ? step : -step,
          behavior: 'smooth'
        });
      });
    });
  }

  function initTimeline(root) {
    var items = root.querySelectorAll('[data-b2-stage]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-active'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('is-active');
      });
    }, { rootMargin: '0px 0px -25% 0px', threshold: 0.4 });
    items.forEach(function (el) { io.observe(el); });
  }

  function initDialog(root) {
    var dialog = root.querySelector('dialog[data-b2-dialog]');
    var open = root.querySelector('[data-b2-dialog-open]');
    if (!dialog || !open || !dialog.showModal) return;
    open.addEventListener('click', function () { dialog.showModal(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.hasAttribute('data-b2-dialog-close')) dialog.close();
    });
  }

  function initChecklist(root) {
    var counter = root.querySelector('[data-b2-check-count]');
    var items = root.querySelectorAll('[data-b2-check]');
    if (!items.length) return;
    items.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var on = btn.classList.toggle('is-ticked');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (counter) counter.textContent = root.querySelectorAll('[data-b2-check].is-ticked').length;
      });
    });
  }

  function initVariants(root) {
    var chips = root.querySelectorAll('[data-b2-variant]');
    if (!chips.length) return;
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-b2-price]');
    var compareEl = root.querySelector('[data-b2-compare]');
    var submit = root.querySelector('.product--add-to-cart-button');
    var atcText = submit && submit.querySelector('[data-add-to-cart-text]');
    var atcLabel = atcText ? atcText.innerHTML : '';
    chips.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var available = radio.dataset.available === 'true';
        root.querySelectorAll('.b2h-vchip').forEach(function (l) {
          l.classList.toggle('is-selected', l.contains(radio));
        });
        if (idInput) {
          idInput.value = radio.value;
          idInput.disabled = !available;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
        if (compareEl) {
          if (radio.dataset.compare) { compareEl.textContent = radio.dataset.compare; compareEl.hidden = false; }
          else { compareEl.hidden = true; }
        }
        if (submit) {
          submit.disabled = !available;
          if (atcText) {
            if (available) {
              var base = atcText.dataset.b2Label || atcLabel;
              if (atcText.dataset.b2LabelPrice === 'true' && radio.dataset.price) {
                atcText.textContent = '';
                atcText.appendChild(document.createTextNode(base + ' · '));
                var cp = document.createElement('span');
                cp.setAttribute('data-b2-cta-price', '');
                cp.textContent = radio.dataset.price;
                atcText.appendChild(cp);
              } else {
                atcText.textContent = base;
              }
            } else {
              atcText.textContent = atcText.dataset.unavailableText || 'Sold out';
            }
          }
        }
        var thumb = radio.dataset.mediaId && root.querySelector('[data-b2-thumb][data-media-id="' + radio.dataset.mediaId + '"]');
        if (thumb) { thumb.click(); }
        else if (radio.dataset.mediaSrc) {
          var mainImg = root.querySelector('[data-b2-main] img');
          if (mainImg) { mainImg.src = radio.dataset.mediaSrc; mainImg.removeAttribute('srcset'); }
        }
        if (radio.dataset.price) {
          document.querySelectorAll('[data-belo-sticky-price]').forEach(function (el) { el.textContent = radio.dataset.price; });
        }
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* older browsers: skip URL sync */ }
      });
    });
  }

  function initQty(root) {
    var wrap = root.querySelector('[data-b2-qty]');
    if (!wrap) return;
    var input = root.querySelector('[data-b2-qty-input]');
    var count = wrap.querySelector('[data-b2-qty-count]');
    function set(n) {
      n = Math.max(1, Math.min(99, n || 1));
      if (input) { input.value = n; input.dispatchEvent(new Event('change', { bubbles: true })); }
      if (count) count.textContent = n;
    }
    var dec = wrap.querySelector('[data-b2-qty-dec]');
    var inc = wrap.querySelector('[data-b2-qty-inc]');
    if (dec) dec.addEventListener('click', function () { set((parseInt(input && input.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { set((parseInt(input && input.value, 10) || 1) + 1); });
  }

  function initStickyBar() {
    // Drive the shared belo-sticky-bar section from the belo2 hero
    // (belo-pdp.js only watches the old .belo-pdp--hero-buybox hook).
    var hero = document.querySelector('.belo2-hero');
    var bar = document.getElementById('beloStickyBar');
    if (!hero || !bar || !('IntersectionObserver' in window)) return;
    if (bar.__beloHero === hero) return;
    if (bar.__beloIO) bar.__beloIO.disconnect();
    bar.__beloHero = hero;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0 });
    bar.__beloIO = io;
    io.observe(hero);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.belo2').forEach(function (root) {
      if (root.dataset.b2Init) return;
      root.dataset.b2Init = '1';
      initGallery(root);
      initCarousel(root);
      initTimeline(root);
      initDialog(root);
      initChecklist(root);
      initVariants(root);
      initQty(root);
    });
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) {
      e.target.querySelectorAll('.belo2').forEach(function (r) { delete r.dataset.b2Init; });
      initAll(e.target);
    }
  });
})();
